import Switch from '@material-ui/core/Switch';
import PropTypes from 'prop-types';

import { useStyles } from './useStyles';

export const CustomSwitch = ({ className, size, ...props }) => {
  const styles = useStyles({ size });

  return (
    <Switch
      className={className}
      classes={{
        root: styles.root,
        // Created 2 separate styles since Mui has an issue with reading props for nested classes
        switchBase: size === 'small' ? styles.smallSwitchBase : styles.mediumSwitchBase,
        thumb: styles.thumb,
        track: styles.track,
        checked: styles.checked,
        colorPrimary: styles.colorPrimary,
        colorSecondary: styles.colorSecondary,
        disabled: styles.disabled,
      }}
      focusVisibleClassName={styles.focusVisible}
      {...props}
    />
  );
};

CustomSwitch.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType(['small', 'medium']),
};

CustomSwitch.defaultProps = {
  className: null,
  size: 'medium',
};
